// footer.js
import React from "react";
import "../styles/footer.css";
import emailIcon from "../assets/img/mail-icon.svg";
import phoneIcon from "../assets/img/whats-icon.svg";

const Footer = () => {
    return (
        <footer>
            <div className="footer-content">

                <div className="footer-contact">
                    <div className="contact-item">
                        <img src={emailIcon} alt="Email" />
                        <a href="mailto:emychrystinne@gmail.com">emychrystinne@gmail.com</a>
                    </div>
                    <div className="contact-item">
                        <img src={phoneIcon} alt="Telefone" />
                        <a href="https://wa.me/+5582988073209">+55 (82) 98807-3209</a>
                    </div>
                </div>
                <div className="footer-links">
                    <a href="#sobre">Sobre</a>
                    <a href="#projetos">Projetos</a>
                    <a href="#conhecimentos">Conhecimentos</a>
                    <a href="#contato">Contato</a>
                </div>
            </div>
            <div className="footer-copyright">
                <p>&copy; 2024 Emy Chrystinne. Todos os direitos reservados.</p>
            </div>
        </footer>
    );
};

export default Footer;